// Tracks where the currently-open item preview modal was launched from (e.g.
// 'searchDropdown', 'searchResults', 'library', 'recent') so preview analytics
// can attribute usage to its source. Cleared when the preview closes.
export default function (state = null, action) {
  switch (action.type) {
    case 'UPDATE_PREVIEW_ITEM':
      return action.itemId ? (action.source || null) : null

    case 'LOGOUT':
      return null
    default:
      return state
  }
}
